import React from 'react';
import { TextField } from '@material-ui/core';
import { useDebounce, useDidUpdateEffect, useState } from 'hooks';

const filterInputStyle = {
    fontSize: 12,
    border: '1px solid #d0d0d0',
    borderRadius: 3,
    padding: '1px 6px',
    backgroundColor: '#fff',
    height: 22,
    boxSizing: 'border-box',
};

export default function AnalyticsRangeFilter({ column }) {
    const { filterValue, setFilter } = column;
    const [gte, setGte] = useState(filterValue?.gte ?? '');
    const [lte, setLte] = useState(filterValue?.lte ?? '');
    const debouncedGte = useDebounce(gte, 500);
    const debouncedLte = useDebounce(lte, 500);

    useDidUpdateEffect(() => {
        const hasGte = debouncedGte !== '' && debouncedGte != null;
        const hasLte = debouncedLte !== '' && debouncedLte != null;
        if (!hasGte && !hasLte) {
            setFilter(undefined);
        } else {
            setFilter({
                ...(hasGte ? { gte: Number(debouncedGte) } : {}),
                ...(hasLte ? { lte: Number(debouncedLte) } : {}),
            });
        }
    }, [debouncedGte, debouncedLte]);

    return (
        <div>
            <TextField
                size="small"
                placeholder="≥"
                value={gte}
                onChange={(e) => setGte(e.target.value)}
                InputProps={{ disableUnderline: true, style: filterInputStyle }}
                inputProps={{ style: { padding: 0 } }}
                style={{ width: 'calc(50% - 2px)', marginRight: 4 }}
            />
            <TextField
                size="small"
                placeholder="≤"
                value={lte}
                onChange={(e) => setLte(e.target.value)}
                InputProps={{ disableUnderline: true, style: filterInputStyle }}
                inputProps={{ style: { padding: 0 } }}
                style={{ width: 'calc(50% - 2px)' }}
            />
        </div>
    );
}
